import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {FormGroup} from '@angular/forms';

import {Card} from '../domain/card';
import {CardActionBase} from '../domain/card-actions/card-action.base';

@Component({
  selector: 'crds-card',
  template: `
      <div [ngSwitch]="card.type">
          <crds-carousel-form *ngSwitchCase="'carouselSingle'" [form]="formGroup" [card]="card"></crds-carousel-form>
          <crds-carousel-multiple-form *ngSwitchCase="'carousel'" [form]="formGroup" [card]="card"></crds-carousel-multiple-form>
          <crds-image-capture-form *ngSwitchCase="'imageCapture'" [form]="formGroup" [card]="card"></crds-image-capture-form>
          <crds-ocr-form *ngSwitchCase="'ocr'" [form]="formGroup" [card]="card"></crds-ocr-form>
          <crds-address-form *ngSwitchCase="'address'" [form]="formGroup" [card]="card"></crds-address-form>
          <crds-information-form *ngSwitchCase="'info'" [form]="form" [card]="card"></crds-information-form>
          <crds-consent-form *ngSwitchCase="'consent'" [form]="form" [formKey]="card.key" [card]="card"></crds-consent-form>
          <crds-default-form *ngSwitchDefault [form]="form" [formKey]="card.key" [card]="card"></crds-default-form>
      </div>
  `,
  styleUrls: ['../sass/main.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CardComponent implements OnInit {
  @Input() card: Card<CardActionBase>;
  @Input() form: FormGroup;

  formGroup: FormGroup;

  ngOnInit(): void {
    this.formGroup = this.form.get(this.card.key) as FormGroup;
  }
}
